export default {"src":"/_next/static/media/change_history-fill.49f27c6f.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};